import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "../lib/api";

// Secure claim link: /claim/<token> checks the token, then opens the page's claim flow.
export default function ClaimLinkPage() {
  const { token } = useParams();
  const nav = useNavigate();
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/public/claim/${token}`).then((r) => { sessionStorage.setItem("lif_claim_token", token); const promo = new URLSearchParams(window.location.search).get("promo"); nav(`/v/${r.data.prospect_id}?claim=1${promo ? `&promo=${encodeURIComponent(promo)}` : ""}`, { replace: true }); }).catch((e) => setErr(formatApiError(e)));
  }, [token, nav]);
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--bg)]" data-testid="claim-link-page">
      {err ? <div className="max-w-md text-center space-y-3" data-testid="claim-link-error"><p className="font-serif text-3xl">Claim link problem</p><p className="text-sm text-[var(--muted)]">{err}</p>
        <Link to="/vendors" className="btn-gold inline-flex">Browse vendors</Link></div>
        : <Loader2 className="w-6 h-6 animate-spin text-[var(--gold)]" />}
    </div>
  );
}
